import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { GeneralQuestions } from 'src/app/tga/shared/models/models';
import { selectGeneralQuestions } from 'src/app/tga/store/tga.selectors';

import {
  PotatoType,
  TGADropdownQuestion,
  TgaInputType,
  TGAQuestion,
  TGARadioButtonQuestion,
} from '../../../models/question-models';
import { SharedSpecificQuestionnaireService } from '../shared/shared-specific-questionnaire.service';

@Injectable({
  providedIn: 'root',
})
export class SpecificGeneralQuestionsService extends SharedSpecificQuestionnaireService {
  readonly store = inject(Store);

  public readonly cropVarietyKey = 'variety';
  public readonly potatoTypeKey = 'potatoType';
  public readonly exportKey = 'export';
  tgaState$: Observable<GeneralQuestions | null> = of();
  public generalQuestions: TGAQuestion<TgaInputType>[] = [];


  initializeGeneralQuestions(varietiesOptions: { key: string; value: string }[], isAtLeastAdvisor: boolean): void {
    this.getQuestions(varietiesOptions, isAtLeastAdvisor).subscribe((questions) => {
      this.generalQuestions = questions;
    });
  }

  initValues(cropVariety: { key: string; value: string } | undefined): TGAQuestion<TgaInputType>[] {
    if (cropVariety) {
      const varietyQuestion = this.generalQuestions.find((q) => q?.key === this.cropVarietyKey);
      if (varietyQuestion) {
        varietyQuestion.value = cropVariety.key;
      }
    }
    this.tgaState$ = this.store.select(selectGeneralQuestions);
    this.tgaState$.subscribe((state) => {
      if (state) {
        for (const question of this.generalQuestions) {
          if (question.key === this.potatoTypeKey) {
            question.value = state.targetPurpose;
          } else if (question.key === this.exportKey) {
            question.value = state?.targetExport ? 'yes' : 'no';
          }
        }
      }
    });
    return this.generalQuestions;
  }

  getQuestions(varietiesOptions: { key: string; value: string }[], isAtLeastAdvisor: boolean): Observable<TGAQuestion<TgaInputType>[]> {
    const potatoTypeOptions = Object.entries(PotatoType).map(([key, value]) => ({
      key,
      value,
    }));

    return of([
      new TGADropdownQuestion({
        options: {
          key: this.cropVarietyKey,
          label: 'TGA.Questionnaire.GeneralQuestions.Variety.Question',
          placeholder: 'TGA.Questionnaire.GeneralQuestions.Variety.Placeholder',
          required: true,
          description: isAtLeastAdvisor ? undefined : 'TGA.Questionnaire.GeneralQuestions.Variety.DescriptionCustomer',
          isDisabled: !isAtLeastAdvisor,
          order: 1,
          options: varietiesOptions.map((option) => ({
            key: option.key,
            value: option.value,
          })).sort((a, b) => a.value.localeCompare(b.value)),
        },
      }),
      new TGARadioButtonQuestion({
        key: this.potatoTypeKey,
        label: 'TGA.Questionnaire.GeneralQuestions.PotatoType.Question',
        required: true,
        order: 2,
        options: potatoTypeOptions,
      }),
      new TGARadioButtonQuestion({
        key: this.exportKey,
        label: 'TGA.Questionnaire.GeneralQuestions.Export.Question',
        required: true,
        order: 3,
        options: [
          { key: 'yes', value: 'TGA.Questionnaire.GeneralQuestions.Export.Yes' },
          { key: 'no', value: 'TGA.Questionnaire.GeneralQuestions.Export.No' },
        ],
      }),
    ]);
  }
}
